/*
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-04-15 13:32:47
 * @Description: cache history search
 */
import { getTaskQueryDisplayStr } from '@/utils/historyItems'
import cloneDeep from 'lodash/cloneDeep'
function setHistory (arr, params) {
  if (arr.length >= 30) {
    arr.pop()
  }
  const index = arr.findIndex(a => a.label === params.label)
  if (~index) {
    arr.unshift(arr.splice(index, 1)[0])
    return
  }
  arr.unshift(params)
}

export default {
  namespaced: true,
  state: {
    taskHistory: {
      searchList: [],
      userOptions: []
    }
  },
  getters: {
    getTaskUserOptions: (state) => (path) => {
      return state.taskHistory.userOptions.find(u => u.path === path) || {}
    }
  },
  mutations: {
    pushTaskSearchHistory (state, { searchObj, timeZone }) {
      const query = getTaskQueryDisplayStr(searchObj, timeZone)
      if (!query) return
      // const queryStr = JSON.stringify(query)
      // setHistory(state.taskHistory.searchList, { value: params, label: queryStr.substring(1, queryStr.length - 1) })
      setHistory(state.taskHistory.searchList, { value: cloneDeep(searchObj), label: JSON.stringify(query) })
    },
    deleteTaskSearchHistory (state, index) {
      state.taskHistory.searchList.splice(index, 1)
    },
    setUerOptions ({ taskHistory }, params) {
      const index = taskHistory.userOptions.findIndex(u => u.path === params.path)
      if (~index) {
        taskHistory.userOptions.splice(index, 1, params)
      } else {
        taskHistory.userOptions.push(params)
      }
    }
  }
}
